module.exports = __webpack_public_path__ + "img/img-21.237c9897.svg";